import { FormGroup } from '@angular/forms';
import { GeneratorSearch, PowerSupplySearch } from '@psnb/psnb-api';
import { JsonAdvancedSearchResult } from '@psnb/nwt-api';

// Type alias for backward compatibility - use PowerSupplySearch from API
export type SearchPowerSupply = PowerSupplySearch;

export interface DeployGeneratorViewModel {
  comments: string;
  deployGeneratorButtonDisabled: boolean;
  formGroup: FormGroup;
  fuelTankAssetSearchResult: GeneratorSearch[];
  generatorAssetSearchResult: GeneratorSearch[];
  generatorLocalId: string | undefined;
  generatorQrCodeAssetId: string | undefined;
  generatorSerialNumber: string | undefined;
  isLoadingLocation: boolean;
  isLoadingMacData: boolean;
  isLoadingNodeData: boolean;
  isNodeSearchButtonEnabled: boolean;
  latitudeValue: number | undefined;
  longitudeValue: number | undefined;
  macSearchResult: SearchPowerSupply[];
  nodeSearchResult: JsonAdvancedSearchResult[];
  noPowerSupplyFound: boolean;
  powerSupplyNameSearchResult: PowerSupplySearch[];
  selectedPowerSupplyName: string;
  serialNumberSearchResult: GeneratorSearch[];
}

export enum PowerSupplySearchDistance {
  Default = 2
}

export interface PowerSupplySearchParams {
  address: string | undefined;
  distance: number;
  headendOrCommunity: string | undefined;
  latitude: number | undefined;
  longitude: number | undefined;
  macAddress: string | undefined;
  node: string | undefined;
  nodeCommunintyServed: string | undefined;
  nodeId: number | undefined;
  nodeText: string | undefined;
  powerSupplyId: number | undefined;
  powerSupplyName: string | undefined;
  regionId: number | undefined;
}
